import { render, staticRenderFns } from "./AlimentosList.vue?vue&type=template&id=c73e22fa&"
import script from "./AlimentosList.vue?vue&type=script&lang=js&"
export * from "./AlimentosList.vue?vue&type=script&lang=js&"
import style0 from "./AlimentosList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports